<router-outlet></router-outlet>

<ui-modal
    class="modal"
    type="confirm"
    [isVisible]="isMaintenanceModalVisible()"
    [isBackdropBlurred]="true"
    [closable]="false"
    [isAppendedToBody]="true"
>
    <div class="modal__body">
        <h2 class="modal__message">{{ maintenanceMessage() }}</h2>
        <h2 class="modal__responsible">{{ maintenanceResponsible() }}</h2>
    </div>
</ui-modal>
